{
	"correct": [
		"Yes, that's the one!",
		"Wonderful!",
		"Yes! Lovely stuff.",
		"Yes, that's correct.",
		"Yes, that's perfect.",
		"Excellent!",
		"Yes! Top job.",
		"Yes, excellent.",
		"Yes, that's right.",
		"Yes, that's it, well done.",
		"Yes. Good stuff."
	],
	"incorrect": [
		"Sorry, that's not it",
		"No, that's not it",
		"No, try again",
		"No, not quite right, I'm afraid",
		"No, not quite right",
		"Sorry, that's incorrect",
		"That's incorrect, I'm afraid",
		"That is incorrect",
		"Sorry, that is incorrect",
		"That's not right, I'm afraid",
		"Incorrect, I'm afraid",
		"Incorrect, unfortunately"
	]
}
